<template>
  <div v-frag>
    <CardIeaAppMain colorCard="#A7BA38" title="">
      <!-- <v-row> -->
      <Loader />
      <v-col cols="12" sm="12" xs="12" md="12" lg="12" xl="12">
        <v-btn
          class="mx-2"
          fab
          dark
          small
          color="success"
          @click="$router.push({ name: 'Home' })"
          v-if="user && user.IDStB"
        >
          <v-icon dark> mdi-keyboard-backspace </v-icon>
        </v-btn>
        <br /><br />
        <div
          class="text-xs-h4 text-sm-h4 text-md-h4 text-lg-h4 text-xl-h4 primary--text"
          style="color: white !important;"
        >
          {{ title }}
        </div>

        <div v-if="user.borrado_real == '1'">
          <v-col cols="12" xs="12" sm="12" md="12" xl="12" lg="12">
            <v-alert prominent type="error">
              <ul>
                <li>
                  La acción no es posible de realizar, Usted se encuentra dado
                  de baja
                </li>
                <li>
                  Recordá que para poder concertar la baja deberás tener
                  abonado hasta la cuota del mes en curso. En caso de tener
                  deuda, abonala antes del día del turno
                  <v-btn
                    href="https://public.terminalasecundaria.ar/pagar-curso"
                    small
                    class="white--text text-decoration-underline font-weight-regular"
                    depressed
                    text
                    color="white"
                    >Haciendo Click Aqui!</v-btn
                  >
                </li>
                <li>
                  Usted tiene deuda pendiente o se encuenta en estado de baja!
                </li>
              </ul>
            </v-alert>
          </v-col>
        </div>
        <div v-else-if="proceso_anterior_modo_verano">
          <v-col cols="12" xs="12" sm="12" md="12" xl="12" lg="12">
            <v-alert prominent type="error">
              <ul>
                <li>Usted ya tiene un proceso de baja solicitado</li>
              </ul>
            </v-alert>
          </v-col>
        </div>
        <div v-else-if="finalizar_proceso_modo_verano">
          <v-col cols="12" xs="12" sm="12" md="12" xl="12" lg="12">
            <v-alert prominent type="success">
              <ul>
                <li>Se ha registrado su proceso de baja</li>
              </ul>
            </v-alert>
          </v-col>
        </div>
        <div v-else-if="!iniciarProceso && !mostrarCalendario" class="text-center">
          <v-btn
            class="mt-10 "
            :disabled="disabled_carga_inicial"
            color="primary"
            @click="guardarInicioProcesoBaja()"
            >Iniciar Proceso
          </v-btn>
        </div>

        <div v-else-if="iniciarProceso && !mostrarCalendario" style="width: 100%">
          <v-col cols="12" sm="12" xs="12" md="12" lg="12" xl="12">
            <v-card elevation="0" class="rounded-xl" color="secondaryApp">
              <v-card-title
                style="
                  display: flex;
                  justify-content: center;
                  background-color: rgb(255, 5, 5);
                  color: white;
                "
              >
                <div>
                  <h3 class="text-md-h4">
                    Su proceso de Baja Ha Iniciado!
                  </h3>
                  <h4 class="text-xs-h4 text-center mb-5">
                    Por favor seguir las siguientes indicaciones
                  </h4>
                </div>

                <div>
                  <ul>
                    <li>
                      Debe tener en cuenta que para obtener la baja debe tener
                      abonado el mes en curso y no poseer deuda anterior
                    </li>
                    <li>
                      Debe seleccionar una entrevista de baja en los próximos 30
                      días.
                    </li>
                    <li>El último mes que abonará será: {{ currentMonth }}</li>
                    <li>Tendra oprtunidad de finalizar todo el proceso hasta: {{ fecha_fin }}, de lo contrario tendra que inciar el proceso nuevamente!</li>
                  </ul>
                </div>

                .
              </v-card-title>

              <div class="text-center">
                <v-btn
                  class="mt-10 "
                  color="primary"
                  @click="mostrarCalendario = true"
                  >Continuar
                </v-btn>
              </div>
            </v-card>
          </v-col>
        </div>

        <div v-if="mostrarCalendario">
          <div v-if="user.alumno_mora" style="width: 100%">
            <v-col cols="12" xs="12" sm="12" md="12" xl="12" lg="12">
              <v-alert prominent type="warning">
                <ul>
                  <li>Para solicitar la baja primero debe abonar su deuda</li>
                  <li>
                    Recordá que para poder concertar la baja deberás tener
                    abonado hasta la cuota del mes en curso. En caso de tener
                    deuda, abonala antes del día del turno
                    <v-btn
                      href="https://public.terminalasecundaria.ar/pagar-curso"
                      small
                      class="white--text text-decoration-underline font-weight-regular"
                      depressed
                      text
                      color="white"
                      >Haciendo Click Aqui!</v-btn
                    >
                  </li>
                  <li>
                    Usted tiene deuda pendiente o se encuenta en estado de mora!
                  </li>
                </ul>
              </v-alert>
            </v-col>
          </div>
          <div v-else-if="user.borrado == '1' || user.excedente" style="width: 100%">
            <v-col cols="12" xs="12" sm="12" md="12" xl="12" lg="12">
              <v-alert prominent type="error">
                <ul>
                  <li>
                    La acción no es posible de realizar, Usted se encuentra dado
                    de baja
                  </li>
                  <li>
                    Recordá que para poder concertar la baja deberás tener
                    abonado hasta la cuota del mes en curso. En caso de tener
                    deuda, abonala antes del día del turno
                    <v-btn
                      href="https://public.terminalasecundaria.ar/pagar-curso"
                      small
                      class="white--text text-decoration-underline font-weight-regular"
                      depressed
                      text
                      color="white"
                      >Haciendo Click Aqui!</v-btn
                    >
                  </li>
                  <li>
                    Usted tiene deuda pendiente o se encuenta en estado de baja!
                  </li>
                </ul>
              </v-alert>
            </v-col>
          </div>
          <div v-else>
            <v-col cols="12" xs="12" sm="12" md="12" xl="12" lg="12">
              <v-alert prominent type="info">
                <ul>
                  <li>
                    Para reservar el turno haz click en el horario disponible
                  </li>

                  <li v-if="deuda == 'true'">
                    Recordá que para poder concertar la baja deberás tener
                    abonado hasta la cuota del mes en curso. En caso de tener
                    deuda, abonala antes del día del turno
                    <v-btn
                      href="https://public.terminalasecundaria.ar/pagar-curso"
                      small
                      class="white--text text-decoration-underline font-weight-regular"
                      depressed
                      text
                      color="white"
                      >Haciendo Click Aqui!</v-btn
                    >
                  </li>
                </ul>
              </v-alert>
            </v-col>

            <v-row align="center" v-if="!user || !user.IDStB">
              <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <label>Tipo de documento</label>
                <v-select
                  v-model="tipo"
                  :items="tipos"
                  item-text="text"
                  item-value="value"
                  label="Selecciona el tipo  de documento"
                  persistent-hint
                  return-object
                  single-line
                  v-on:change="loadData"
                ></v-select>
              </v-col>
              <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <label>Número de documento</label>
                <v-text-field
                  v-model="documento"
                  label="Escribe el número de documento"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
            <!--
          <v-row align="center">
          <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
            <label>Sede del trámite</label>
            <v-select
              v-model="sede"
              :items="sedes"
              item-text="text"
              item-value="value"
              label="Selecciona la sede"
              persistent-hint
              return-object
              single-line
              v-on:change="loadData"
            ></v-select>
          </v-col>
        </v-row>
        -->
            <v-row align="center">
              <v-col
                cols="12"
                xs="12"
                sm="12"
                md="12"
                lg="12"
                xl="12"
                v-if="sede.value != ''"
              >
                <FullCalendar
                  class="demo-app-calendar"
                  :options="calendarOptions"
                  ref="calendar"
                >
                  <template v-slot:eventContent="arg">
                    <b>{{ arg.timeText }}</b>
                    <i>{{ arg.event.title }}</i>
                  </template>
                </FullCalendar>
              </v-col>
            </v-row>
          </div>
        </div>
      </v-col>
      <v-row justify="center">
        <v-dialog v-model="dialogModoVerano" persistent max-width="610">
          <v-card>
            <v-card-title class="headline" onselectstart="return false;" oncontextmenu="return false;"
              >¿ Está Seguro de Iniciar El Proceso de Baja ?
            </v-card-title>
            <v-card-text>
              <p>
                Para procesar su solicitud de baja de manera exitosa, le recordamos que no debe registrar deudas
                pendientes.
              </p>
              <p>
                Asimismo, es requisito contar con el pago del mes en curso (enero) al momento de realizar el trámite. En
                caso de tener saldos pendientes, podrá regularizarlos y reiniciar el proceso de baja posteriormente.
              </p>
              <p>
                Nota importante: Si la baja se hace efectiva durante los meses de enero o febrero, usted deberá volver a
                abonar la matrícula de inscripción para el ciclo de marzo 2026, en caso que desee retomar sus estudio y
                no podrá acceder a descuentos ni becas en los aranceles.
              </p>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text @click="dialogModoVerano = false"> Cancelar </v-btn>
              <v-btn color="green darken-1" text @click="guardarProcesoBajaModoVerano()">
                Finalizar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>

      <template>
        <v-row justify="center">
          <v-dialog v-model="dialog" persistent max-width="600px">
            <v-card>
              <v-card-title>
                <span class="headline">Reservar turno</span>
              </v-card-title>

              <v-card-text>
                <v-container>
                  <v-row>
                    <!--
                     <v-col cols="12" xs="12" sm="12" md="12" xl="12" lg="12">
                      <v-alert
                        prominent
                        type="info"
                      >
                       Tenga en cuenta que sólo es para retiro o entrega de documentación
                      </v-alert>
                    </v-col>
                    -->
                    <v-col cols="12">
                      <v-textarea
                        name="input-7-1"
                        v-model="texto"
                        label="Por favor indique el motivo del turno"
                      ></v-textarea>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="dialog = false">
                  Cancelar
                </v-btn>
                <v-btn color="blue darken-1" text @click="apartar"> OK </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-row>
      </template>

      <!-- </v-row> -->
    </CardIeaAppMain>
  </div>
</template>

<script>
// import CardIeaApp from "../../components/CardIeaApp";
import CardIeaAppMain from "../../components/CardIeaAppMain";
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import timeGridPlugin from "@fullcalendar/timegrid";
import Route from "../../config/RouteApi";
import esLocale from "@fullcalendar/core/locales/es";
import moment from "moment";
import Loader from "../../components/Loader.vue";
import store from "../../store";
moment.locale("es");

export default {
  name: "MateriaCodigoClaseVideo",
  components: {
    // CardIeaApp,
    CardIeaAppMain,
    Loader,
    FullCalendar
  },

  data: function() {
    return {
      fecha_fin: null,
      mostrarCalendario: false,
      currentMonth: "",
      modo_verano: false,
      dialogModoVerano: false,
      proceso_anterior_modo_verano: false,
      finalizar_proceso_modo_verano: false,
      iniciarProceso: false,
      disabled_carga_inicial: true,
      title: "Solicitud de Baja",
      sede: { text: "", value: "" },
      sedes: [],
      tipo: { text: "DNI", value: 1 },
      documento: "",
      tipos: [
        { text: "DNI", value: 1 },
        { text: "PASAPORTE", value: 2 }
      ],
      editable: true,
      dialog: false,
      texto: "",
      turno_id: "",
      calendarOptions: {
        weekends: "false",
        plugins: [dayGridPlugin, interactionPlugin, timeGridPlugin],
        initialView: "dayGridMonth",
        headerToolbar: {
          left: "dayGridMonth,timeGridWeek,timeGridDay",
          center: "title",
          right: "prev,next"
        },
        validRange: {
          start: moment().format("YYYY-MM-DD")
        },
        locale: esLocale,
        eventClick: this.handleEventClick,
        events: ""
      }
    };
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    deuda() {
      return this.$store.getters.user.deudaAlumno;
    }
  },
  mounted() {
    store.dispatch("loader", true);
    this.getCurrentMonth();
    this.getModoVerano();
    console.log(this.deuda);
    this.$API
      .get({
        url: "sedes",
        data: {}
      })
      .then(res => {
        this.sedes = res;
        this.sede.value = this.sedes.at(-1).value;
        this.loadData();
      })
      .catch(err => {
        console.log(err);
      });
  },

  methods: {
    handleEventClick(clickInfo) {
      let datos = clickInfo.event.extendedProps;

      if (datos.turno_id && !datos.block) {
        this.dialog = true;
        this.turno_id = datos.turno_id;
      }
    },

    async validarDeuda() {
      this.$API
        .get({
          url: "validar-deuda",
          data: {}
        })
        .then(res => {
          this.deuda = res.deuda;
        })
        .catch(err => {
          console.log(err);
        });
    },
    async getModoVerano() {
      this.$API
        .get({
          url: "proceso-baja/get-modo-verano-status",
          data: {}
        })
        .then(res => {
          if (res == "0") {
            store.dispatch("loader", false);
            this.modo_verano = false;
            this.disabled_carga_inicial = false;
          } else {
            this.modo_verano = true;
            this.$API
              .post({
                url: "procebo-baja/buscar-proceso-anterior",
                data: {
                  alumno_id: this.user.IDStB
                }
              })
              .then(resal => {
                this.proceso_anterior_modo_verano = !!resal.proceso_anterior;
                this.disabled_carga_inicial = !!resal.proceso_anterior;
                store.dispatch("loader", false);
              })
              .catch(erral => {
                console.log(erral);
              });
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    async loadData() {
      this.calendarOptions.events = Route + "turno-presencial/show/" + 18;
    },
    async apartar() {
      //this.dialog = false;
      if (this.texto.trim() == "") {
        alert("Debe colocar un motivo para el turno");
        return;
      }

      let dataSend = {
        text: this.texto,
        turno_id: this.turno_id,
        documento: this.documento,
        tipoDocumento: this.tipo.value,
        alumno_id: this.user.IDStB,
        motivo: "baja"
      };

      let url = "turno-presencial/inscribirTurno";

      await this.$API
        .post({
          url: url,
          data: dataSend
        })
        .then(() => {
          this.texto = "";
          this.turno_id = 0;
          this.dialog = false;

          let calendarApi = this.$refs.calendar.getApi();
          calendarApi.refetchEvents();
        });
    },
    async guardarInicioProcesoBaja() {
      if (this.modo_verano) {
        this.dialogModoVerano = true;
        return;
      }
      this.$API
        .post({
          url: "iniciar-proceso-baja",
          data: {
            alumno_id: this.user.IDStB
          }
        })
        .then(res => {
          if (res.proceso_nuevo) {
            this.iniciarProceso = true;
          } else {
            this.mostrarCalendario = true;
          }

          this.fecha_fin = res.fecha_finalizacion;
        })
        .catch(err => {
          console.log(err);
        });
    },
    async guardarProcesoBajaModoVerano() {
      this.$API
        .post({
          url: "iniciar-proceso-baja",
          data: {
            alumno_id: this.user.IDStB
          }
        })
        .then(() => {
          this.dialogModoVerano = false;
          this.finalizar_proceso_modo_verano = true;
        })
        .catch(err => {
          console.log(err);
        });
    },
    getCurrentMonth() {
      this.currentMonth = moment()
        .format("MMMM")
        .toUpperCase();
    }
  }
};
</script>
<style scoped>
   .v-application .primary--text {
      color: white !important;
      caret-color: #125ea5 !important;
  }
  .v-dialog > .v-card > .v-card__title {
    font-size: 1.25rem;
    font-weight: 500;
    letter-spacing: 0.0125em;
    padding: 16px 24px 10px;
    background-color: #125ea5 !important;
  }
  /* Títulos responsivos */
  .text-xs-h4 {
    font-size: 1.2rem;
  }
  .text-sm-h4 {
    font-size: 1.4rem;
  }
  .text-md-h4 {
    font-size: 1.6rem;
  }
  .text-lg-h4 {
    font-size: 1.8rem;
  }
  .text-xl-h4 {
    font-size: 2rem;
  }

  ::v-deep .fc .fc-toolbar-title {
    font-size: 1.75em;
    margin: 0;
    color: white;
  }

  ::v-deep .fc .fc-timegrid-axis-cushion {
    max-width: 60px;
    flex-shrink: 0;
    color: white !important;
  }

  ::v-deep .fc .fc-timegrid-slot-label {
    vertical-align: middle;
    color: white;
  }

  ::v-deep .fc .fc-col-header-cell-cushion {
    display: inline-block;
    padding: 2px 4px;
    color: white !important;
  }

  ::v-deep .fc .fc-daygrid-day-number {
    position: relative;
    z-index: 4;
    padding: 4px;
    color: white !important;
  }

  ::v-deep .fc .fc-daygrid-day-frame {
    position: relative;
    min-height: 100%;
    background-color: #125ea500 !important;
  }

  /* Ajustar el calendario para pantallas pequeñas */
  @media (max-width: 600px) {

    .v-application .primary--text {
      color: white !important;
      caret-color: #125ea5 !important;
      text-align: center;
    }
    ::v-deep .fc-dayGridMonth-button,
    ::v-deep .fc-timeGridWeek-button {
      display: none !important; /* Oculta los botones de 'Mes' y 'Semana' */
    }
        /* Mover los controles (flechas y título) a la parte inferior */
    ::v-deep .fc .fc-toolbar {
      flex-direction: column; /* Esto pone los controles en una columna */
      justify-content: center;
      align-items: center;
      margin-top: 10px;
    }

    ::v-deep .fc .fc-toolbar-title {
      font-size: 1.4em;
      margin-bottom: 10px;
      margin-top:10px;
    }

    ::v-deep .fc .fc-button {
      font-size: 1.2rem; /* Reducir el tamaño de las flechas */
    }

    ::v-deep .fc .fc-daygrid-day-frame {
      min-height: 75px; /* Aumentar la altura de las celdas en dispositivos pequeños */
    }

    /* Aumentar la altura del calendario */
    .demo-app-calendar {
      height: 100vh !important; /* Hacer que el calendario ocupe más espacio verticalmente */
    }

    /* Asegurar que los días y eventos estén centrados y no se solapen */
    ::v-deep .fc .fc-daygrid-day-number {
      padding: 6px;
      font-size: 1rem; /* Hacer el texto más grande para mayor legibilidad */
    }

    ::v-deep .fc .fc-timegrid-slot-label {
      font-size: 1.1rem;
    }

    /* Ajustar los botones y campos de entrada */
    .v-btn {
      font-size: 0.9rem;
    }

    .v-text-field, .v-select {
      font-size: 0.8rem;
    }
  }

  ::v-deep .theme--light.v-card {
    background-color: #FFFFFF !important;
    color: white !important;
  }

  ::v-deep .v-icon__svg {
    height: 24px;
    width: 24px;
    fill: currentColor;
    color: white !important;
  }

  ::v-deep .theme--light.v-select .v-select__selections {
    color: white !important;
  }
  ::v-deep .v-text-field input {
    flex: 1 1 auto;
    line-height: 20px;
    padding: 8px 0 8px;
    max-width: 100%;
    min-width: 0px;
    width: 50%;
    margin-top: -25px;
  }
  
</style>
